const howItWorks = [
    {
        id: 1,
        image: 'productSampling/ProductSampling1.png',
        imageAlt: '',
        title: 'Consumer Sign-Up',
        description: 'Users register and complete detailed profiles, including diets and shopping habits.',
    },
    {
        id: 2,
        image: 'productSampling/peekage-product-sampling-platform.png',
        imageAlt: 'Peekage product sampling platform',
        title: 'Sample Matching',
        description: 'Samples are matched with users based on shopping criteria and consumer profiles.',
    },
    {
        id: 3,
        image: 'productSampling/ProductSampling3.png',
        imageAlt: '',
        title: 'Sample Delivery',
        description: 'Users receive samples via Peekage fulfillment or physical/digital cashback coupons for retail redemption.',
    },
    {
        id: 4,
        image: 'productSampling/ProductSampling4.png',
        imageAlt: '',
        title: 'Product Review',
        description: 'Users test the samples, provide feedback, and write reviews.',
    },
    {
        id: 5,
        image: 'productSampling/ProductSampling5.png',
        imageAlt: '',
        title: 'Follow-Up Discount',
        description: 'After reviewing, users receive follow-up discounts, incentivizing future purchases.',
    },
    {
        id: 6,
        image: 'productSampling/ProductSampling6.png',
        imageAlt: '',
        title: 'Access Insights',
        description: 'Brands access sales data and actionable insights on Peekage’s Insight dashboard.',
    },
];

export default howItWorks;
